<template>
  <div class="product_inf" style="">
    <card title="产品信息">
      <a-carousel autoplay style="width: 100%;">
        <div v-for="(item,index) in productList" style="width: 100%;" :key="index">
          <div style="width: 100%;overflow: hidden;padding:1rem 2rem 0.6rem 1.8rem;">
            <img :src="item.pictures" style="width: 100%;max-height: 14.25rem"/>
          </div>
          <div class="product_inf_content" style="padding:0 2rem 1rem 2rem;">
            <span class="inlineblock width100 yellowfont minfont">产品名称：{{ item.commodityName }}</span>
            <span
              class="inlineblock width100 yellowfont minfont">产品介绍：{{ item.ProductIntroduction }}</span>
            <span class="inlineblock width100 yellowfont minfont">生产基地：{{ item.productionBase }}</span>
            <span
              v-show="item.storageConditions"
              class="inlineblock width100 yellowfont minfont">贮存条件：{{ item.storageConditions }}</span>
          </div>
        </div>
      </a-carousel>
    </card>
  </div>
</template>

<script>
  import card from '@views/general/modules/Card.vue'

  export default {
    name: 'ProductInformation',
    props: {
      productList: {
        type: Array,
        default: () => []
      }
    },
    components: {
      card
    },
    data() {
      return {
        list: [
          require('@assets/card/caomei/image21.png'),
          require('@assets/card/caomei/image23.png'),
          require('@assets/card/caomei/image24.png'),
          require('@assets/card/caomei/image26.png')
        ]

      }
    },
    methods: {}
  }
</script>


<style lang="less" scoped>
.widthStyle {
  width: 14rem;
  word-wrap: break-word;
}

.ant-carousel .slick-slide {
  text-align: center;
  height: 160px;
  line-height: 160px;
  background: #364d79;
  overflow: hidden;
}

.ant-carousel .custom-slick-arrow {
  width: 25px;
  height: 25px;
  font-size: 25px;
  color: #fff;
  background-color: rgba(31, 45, 61, 0.11);
  opacity: 0.3;
}

.ant-carousel .custom-slick-arrow:before {
  display: none;
}

.ant-carousel .custom-slick-arrow:hover {
  opacity: 0.5;
}

.ant-carousel .slick-slide h3 {
  color: #fff;
}


.product_inf {
  /* position: relative; */
  /* height: 7rem; */
  /* background: url(../images/Product_inf_bg.jpg); */
  width: 100%;
  height: 100%;
  margin: 3rem auto;
  top: 8rem;
}

.bg_top {
  width: 100%;
  height: 2rem;
  background: url(../../../assets/card/bg_top.gif);
  background-size: 100% 100%;
}

.bg_con {
  width: 100%;
  height: 100%;
  padding: 0 0.8rem 0 1.1rem;
  background: url(../../../assets/card/bg_con.png) repeat-y;
  background-size: 100%;
}

.bg_bottom {
  width: 100%;
  height: 3rem;
  background: url(../../../assets/card/bg-bottom.png);
  background-size: 100% 100%;
  margin-top: -1rem;
}

.yellowfont {
  color: #faefac;
}

.width100 {
  width: 100%;
  padding: 0.2rem 0;
}

.inlineblock {
  display: inline-block;
}

.minfont {
  font-size: 1rem !important;
}
</style>
